import script from "./AssetManagementPlan.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetManagementPlan.vue?vue&type=script&setup=true&lang=ts"

import "./AssetManagementPlan.vue?vue&type=style&index=0&id=fc63bed8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc63bed8"]])

export default __exports__